interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const alignCls = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return (
    <div className={`flex flex-col ${alignCls}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium tracking-wide text-primary-700">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">{title}</h2>
      {desc && <p className="mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}